import { FIELD_TYPES, DEFAULT_IMPLIED_CONSENT, DEFAULT_IMPLIED_EMAIL_CONSENT_KEY } from 'utils/constants';
import { shouldIncludeImpliedConsent } from 'utils/editorDefaultStates';

const _buildEmailConfig = (gdprSetting) => (
  {
    includeImpliedConsent: shouldIncludeImpliedConsent(gdprSetting),
    impliedConsentData: [
      {
        ...DEFAULT_IMPLIED_CONSENT,
        key: DEFAULT_IMPLIED_EMAIL_CONSENT_KEY,
      },
    ],
  }
);

function fromGQL(obj, gdprSetting) {

  // This is necessary to migrate existing "text" email field types to the "email" field type
  const { value, type: oldType, ...returnableField } = obj;
  const type = FIELD_TYPES.EMAIL;

  // When the email field has already impliedConsentData, we need to keep it,
  // otherwise we need to add the default implied consent data
  const emailConfig = value?.impliedConsentData ? value : _buildEmailConfig(gdprSetting);
  return { ...returnableField, type, editors: { emailConfig } };
}

function overrideFromGQL(obj) {
  const { value, ...returnableField } = obj;
  return { ...returnableField, editors: { emailConfig: value } };
}

function toGQL(opts, gdprSetting) {
  const emailConfig = {
    ...opts.editors.emailConfig,
    includeImpliedConsent: shouldIncludeImpliedConsent(gdprSetting),
  };

  return { value: emailConfig };
}

function overrideToGQL(opts) {
  return { value: opts.editors.emailConfig };
}

export default {
  fromGQL,
  overrideFromGQL,
  toGQL,
  overrideToGQL,
};
